<template>
        <div class="box">
			<span class="text">扫码即可添加邀请人参与活动</span>
            <van-tabs type="card" style="margin-top: 10px;">
                <van-tab title="邀请消费" v-if="qrcode.consume" class="flex-center">
					<div class="flex-center">
						<div class="qrcode">
							<qriously :value="qrcode.consume" :size="200" />
						</div>
					</div>
                </van-tab>
                <van-tab title="邀请充值" v-if="qrcode.recharge" class="flex-center">
					<div class="flex-center">
						<div class="qrcode">
							<qriously :value="qrcode.recharge" :size="200" />
						</div>
					</div>
                </van-tab>
            </van-tabs>
        </div>
</template>

<script>
    import api from '../../assets/js/api'
    import auth from '../../assets/js/auth'
	
    export default {
        name: "InviteConsume",
        components: {
        },
        data(){
            return {
                qrcode: {
					recharge: '',
					consume: ''
				},
				isLoading: true,
				inviteUser: {
					id: '',
					nickname: ''
				}
            };
        },
        computed : {

        },
        watch : {

        },
        created() {
			let self = this;
			this.inviteUser = {
				id: auth.getAuthInfo().id,
				nickname: auth.getAuthInfo().nickname
			}
			api.request('/user/get_activity_invite').then(res => {
				if (res.data.is_consume_invite) self.qrcode.consume = `${window.location.origin}/${self.$route.params.companyId}/oiling/index?inviter_user_id=${self.inviteUser.id}`
				if (res.data.is_recharge_invite) self.qrcode.recharge = `${window.location.origin}/${self.$route.params.companyId}/card/recharge?inviter_user_id=${self.inviteUser.id}`
				console.log(self.qrcode)
			});
        },
        methods : {

        },
		mounted() {
		}
    }
</script>

<style lang="scss" scoped>
	.box {
		border: 1px solid #eaeaea;
		width: 90%;
		margin: auto;
		margin-top: 20px; 
		border-radius: 5px;
		background-color: #ffffff;
		overflow: hidden;
		border-radius: 15px;

		.text {
			display: block;
			width: 100%;
			text-align: center;
			font-size: 16px;
			color: #999;
			padding: 20px;
			box-sizing: border-box;
		}

		.qrcode {
			width:200px;
			height: 200px;
			margin: auto; 
			padding: 10px;
			
		}

		.flex-center {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			height: calc(100vh - 200px);
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/InviteConsume.vue